export default "<app-databases [data]=\"data\"></app-databases>\n"